import { RaiseFundApplicationActionType } from '../../enum/raise-fund-application-action-type.enum';
import { RaiseFundApplicationProcessStatusType } from '../../enum/raise-fund-application-process-status-type.enum';
import { FundRaiseItem } from './fund-raise-item';

export class FundRaiseProcess {
  title: string;
  raiseFundApplicationActionType: RaiseFundApplicationActionType;
  raiseFundApplicationProcessStatusType: RaiseFundApplicationProcessStatusType;
  items: FundRaiseItem[];
  lastUpdatedDate: string;
  isEcfAppFormApproved: boolean;
}
